import { useQuery } from "@tanstack/react-query";

import { AssignmentStatus, assignmentsApi } from "@/api";
import { QueryKey } from "@/query/Query";

import { splitAndSort } from "../Assignments.utils";

/**
 * Shared React Query for a counselor's assignments, split into open and completed ones. Used by the
 * assignments (Aufgaben) page and the sidebar badge. Returns the open ones by default; pass
 * `includeCompleted` to also fetch completed ones (the assignment overview, Aufgabenübersicht,
 * toggles this). The flag is part of the query key so open-only and full result sets are cached
 * separately, while mutations invalidating `[QueryKey.Assignments]` refresh both.
 */
export function useAssignmentsQuery(counselorId?: string, includeCompleted = false) {
  return useQuery({
    queryKey: [QueryKey.Assignments, counselorId, includeCompleted],
    queryFn: () =>
      assignmentsApi.getAllAssignments({
        assignedCounselorId: counselorId,
        status: includeCompleted ? undefined : AssignmentStatus.Open,
      }),
    select: splitAndSort,
  });
}
